import { Heading } from "@elaniintc/goes-design-system";

const Empty = () => {
  return (
    <div className="w-full h-full flex items-center justify-center flex-col text-on-disabled px-20">
      <Heading variant="h6" className="text-center">
        Objeto sin variables generadas
      </Heading>
      <p className="text-center">
        Este objeto no genera variables para usarse más adelante.
      </p>
    </div>
  );
};

export default Empty;
